<template>
  <div v-if="dialogVisible">
    <a-modal v-model:visible="dialogVisible"
             :width="windowWidth+'px'"
             class="xm-char-data-config"
             @ok="handleOk"
             :closable="true"
             :footer="false"
             :title="windowTitle">
      <!--    <a-skeleton v-if="!showPageFlag" />-->
      <div class="import-win-modal-body" :style="'height: '+windowHeight+'px;'">
        <div style="padding: 22px 12px 0 12px;">
          <a-steps progress-dot :current="currentPage">
            <a-step description="选择EXCEL表"/>
            <a-step v-if="props.hasTempData&&props.closeDataCheck!==true" description="导入设置"/>
            <a-step v-if="props.hasTempData" description="导入数据"/>
          </a-steps>
        </div>

        <div style="padding: 20px" v-if="currentPage===0">
          <xm-file-drag accept=".xlsx,.xls"
                        :params="params"
                        :importParams="props.importParams"
                        ref="fileDragRef"
                        @done="doneFile"
                        :multiple="false"
                        :userUploadAction="uploadAction"
                        :fileListFlag="false"
                        :showRemark="false">
            <div>支持 xls, xlsx 等类型的文件</div>
          </xm-file-drag>
        </div>
        <import-page-info  :params="params" :props="props" v-if="currentPage===0"/>

        <import-done-datas :windowHeight="windowHeight"
                           :columns="columns"
                           @nextPage="nextPage"
                           @prePage="prePage"
                           :excelGridFlag="excelGridFlag"
                           :records="gridRecords"
                           v-if="props.closeDataCheck!==true&&currentPage===1"/>
        <import-date-process :confirmUploadAction="confirmUploadAction"
                             :errorDownAction="errorDownAction"
                             :errorList="errorList"
                             :closeDataCheck="props.closeDataCheck"
                             :tableCode="props.tableCode" :excelCode="excelCode"
                             :errorFlag="errorFlag"
                             :errorMsg="errorMsg"
                             :successNum="successNum"
                             :failNum="failNum"
                             @closeWin="closeWin"  v-if="props.closeDataCheck===true?currentPage===1:currentPage===2"/>
      </div>
    </a-modal>
  </div>
</template>


<script lang="ts">
import {defineComponent} from 'vue';


export default defineComponent({
  name: 'import-win-modal',
});
</script>

<script lang="ts" setup>
import ImportDateProcess from "@/main-page/components/import-date-process.vue";
import ImportDoneDatas from "@/main-page/components/import-done-datas.vue";
import ImportPageInfo from "@/main-page/components/import-page-info.vue";
import XmFileDrag from "@/components/xmFileComCtl/xm-file-drag.vue";
import {Modal as AModal, Steps as ASteps, Step as AStep} from 'ant-design-vue';
import {useVModel} from "@vueuse/core";
import {useI18n} from "vue-i18n";

const {t} = useI18n();

const showPageFlag = ref(false);
const loadPage = function () {
  showPageFlag.value = true;
}

interface propsType {
  params:any,
  visible: boolean,
  windowUrl: string,
  windowHeight: number,
  windowWidth: number,
  windowTitle: string,
  props: any,
}

const propsDef = withDefaults(defineProps<propsType>(), {
  visible: false,
  params:{},
  windowUrl: '',
  windowHeight: 500,
  windowWidth: 600,
  props: {},
  windowTitle: '窗口标题',
});
const {props} = toRefs(propsDef);
const uploadAction=ref(unref(props).uploadUrl||`/api/go-lcc/execute/importByTableCode/${unref(props).tableCode}`);
const confirmUploadAction=ref(unref(props).confirmUploadUrl||`/api/go-lcc/execute/passImportByTableCode/${unref(props).tableCode}`);
const errorDownAction=ref(unref(props).errorDownAction||`/api/go-lcc/execute/exportResultByTableCode/${unref(props).tableCode}`);

const iframeSty = computed(() => {
  return {height: propsDef.windowHeight + "px"}
})

const emits = defineEmits(['update:visible', 'handleOk', 'closeWin']);
const dialogVisible = useVModel(propsDef, 'visible', emits);

const handleOk = () => {
  emits('handleOk', {})
}

const currentPage = ref(0);
const gridRecords = ref([]);
const excelCode=ref('');
const columns=ref([]);
const excelGridFlag=ref(false);
const errorFlag=ref(false);
const errorMsg=ref(false);
const errorList=ref([]);
const successNum = ref(0);
const failNum = ref(0);
//上传导入接口刚返回时的原始数据快照，供「填入数据」在关闭弹窗时使用
const rawImportRecords = ref([]);

const captureRawImportRecords = function (records: any) {
  if (Array.isArray(records)) {
    rawImportRecords.value = records;
  } else if (records && Array.isArray(records.excelData)) {
    rawImportRecords.value = records.excelData;
  } else {
    rawImportRecords.value = [];
  }
}

const doneFile = function ({businessId, records}: any) {
  captureRawImportRecords(records);
  if(unref(props).closeDataCheck&&records&&records[0]){
    const failList = records.filter((item:any)=>item.result==="导入失败");
    successNum.value = records.length-failList.length;
    failNum.value = failList.length;
    if(failList.length > 0){
      errorList.value=failList;
      errorMsg.value=failList.msg;
      errorFlag.value=true;
      currentPage.value = 1;
      excelGridFlag.value=true;
      return;
    }
  }
  currentPage.value = 1;
  if(Array.isArray(records)){
    gridRecords.value = records;
  }
  if(records.excelData&&Array.isArray(records.excelData)){
    excelGridFlag.value=true;
    columns.value=records.columns;
    excelCode.value=records.excelCode;
    gridRecords.value = records.excelData;
  }
}
watch(dialogVisible,(newVal:boolean)=>{
  if(newVal===false){
    currentPage.value=0;
    dialogVisible.value=false;
    emits('closeWin', {})
  }
})

const fileDragRef=ref(null);
const prePage=function (){
  currentPage.value = 0;
  fileDragRef.value?.clearFileUpload();
}
const nextPage = () => {
  currentPage.value = 2;
}
const closeWin=function ({flush}){
  emits('closeWin',{flush, records: unref(rawImportRecords)})
  dialogVisible.value=false;
}
const clearImpState = () => {
  errorMsg.value='';
  errorList.value=[];
  errorFlag.value=false;
  currentPage.value = 0;
  excelGridFlag.value=false;
  rawImportRecords.value=[];
}
defineExpose({clearImpState})
</script>

<style lang="less">
.xm-char-data-config {
  .ant-modal-body {
    padding: 0;
  }

  .import-win-modal-body {
    display: flex;
    flex-direction: column;
  }
}
</style>
